import Lottie from "react-lottie";
import LOADING_LOTTIE_ANIMATION_JSON from "../../Lottie-Jsons/InitialLoading.json";

function InitialLoadingAnimationLottie({
  width,
  height,
}: {
  width?: number | string;
  height?: number | string;
}) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LOADING_LOTTIE_ANIMATION_JSON,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return <Lottie options={defaultOptions} height={height} width={width} />;
}

export default InitialLoadingAnimationLottie;
